export default {
    common: {

        en: "英文",
        zh: "中文",

        appName: 'Geo-tagging Tool',
        appNameWebTitle: 'Geo-tagging Tool',
        supportCRSMessage: '***Support WGS84 & HK80 CRS Only***',

        marker: "Geo-tagging",

        helpTitleTips: "Start guided tour",

        //map control
        zoomIn: "Zoom In",
        zoomOut: "Zoom out",
        viewPoint: "Default Extent",

        //tour
        title_tour: "Start Web Tour",

        //Edit & Remove Markers Icon
        editMarkerTools: {
            editMarkersConfirmMessage: "Do you confirm to edit record(s)?",
            removeMarkersConfirmMessage: "Do you confirm to delete record(s)?",
        },

        //layers
        searchResult: "Search Result(s)",
        searchResultBefore: "Total",
        searchResultAfter: "Result(s)",
        identify: "Identify Result(s)",
        layers: "layers",
        topoLayer: "Topographic Map",
        orthoLayer: "Orthophoto Map",
        tableLayer: "Table",
        lotLayer: "Lot",
        buildingLayer: "Building",

        //identify
        coordinates: "Coordinates",
        lotName: "Lot Name",
        prn: "Property Reference No. (PRN)",
        hk80x: "Easting(m)",
        hk80y: "Northing(m)",
        errorIdentifyMessage: "Connection failed. Please try again later.",

        //Add Layer
        reviewGeoData: "VISIT HONG KONG GEODATA STORE",
        addLayer: "Add Layer(Web)",
        removeLayers: "Remove Layers",
        manageLayers: "Manage Layers",
        url: 'URL',
        layerName: 'Layer Name',
        layerType: 'Layer Type',
        layerParams: 'Params (Optional)',
        layerParamsMessage: 'eg: key=abcd1234&name=1234',
        layerLayers: 'Display Layers',
        layerLayersMessage: 'eg: Building,Site,SubSite',
        layerWhere: 'Where / Conditions (Optional) (For ArcGIS Feature Layer only)',
        layerWhereMessage: "eg: City = 'Hong Kong' AND Place = 'Central' ",
        required: 'Required',
        newColumnNameRequired: "Please input a column name",
        style: "Style",
        layerColor: 'The Color of Layer',
        layerNameExisting: 'This layer name is existing.',
        confirmToDeleteLayerMessage: "<br/>Do you confirm to delete this layer ?",
        confirmDeleteAllLayersMessage: "<br/>Do you confirm to delete all layers ?",
        connectLayerNetworkMessage: "Fetch Network Resource Failed",
        connectLayerFailedMessage: "Failed To Read Data",
        zoomInToEnableFeatureMessage: "You might need to zoom-in to map for viewing this layer",
        identifyLocationFailedMessage: "Identify Location Failed, Please try again later",

        copyrightString: "©The Government of the Hong Kong SAR",

        ok: "OK",
        cancel: "Cancel",
        close: "Close",
        clear: "Clear",

        latitude: 'Latitude',
        longitude: 'Longitude',
        // latitude_northing: 'Latitude / Northing',
        // longitude_easting: 'Longitude / Easting',
        northing: 'Northing',
        easting: 'Easting',

        importDialogMessage: "<br/>Would you like to import from previous data?",

        spaceUsed: 'Storage Used',

        number: "Number",
        date: "Date (YYYY-MM-DD)",
        // multiText: "Multi Text",
        multiText: "Text",
        singleText: "Single Text",
        address_zh: "Address(CHI)",
        address_en: "Address(EN)",
        name_zh: "NAME(CHI)",
        name_en: "NAME(EN)",

        //Guided Tour
        guidedTour: "Guided Tour",

        //Menu
        import: "Import Data",
        export: "Download GeoData",
        autoSave: "Temp Storage in Browser(Enabled)",
        noAutoSave: "Temp Storage in Browser(Disabled)",
        lastSavedMessage: "Last Saved Time:",

        //Search Bar
        searchPlace: "Search buildings, facilities, addresses",
        errorSearchPlaceMessage: "Connection failed. Please try again later.",

        //Search result
        recordnotfound: "Record Not Found",
        norecord: "No Record",

        //Matching Dialog
        matchDialog: {
            matchAddNewLocation: "Add New Data",
            matchCopyToSelectedItem: "Copy to Selected Record(No)",
            matchCopyToCoordinate: "Copy Coordinates Information",
            matchAdvancedOption: "Advanced Options",
            matchFields: "Copy Map Information",
            matchFieldsTitle: "Fields Matching",
            createColumn: "New Column",
        },

        //input dialog
        confirm: "Confirmation",
        attention: "Attention",
        confirmInputMessage: "It will use default columns if you don't have  \"Address\" and \"Name\" column type at the table",

        //loading dialog
        loadingDialog: {
            title: "Automatic geo-tagging by location information",
            totalCases: "Total number of input",
            successMatches: "Successful geo-tagged",
            abort: "Abort",
            runInBackground: "Run in Background",
            completedMatchMessage: "Completed to Match Coordinates",
            reachMaxMatchItems: "This function is only available for files less than {number} records",
            connectFailedTasksMessage: "Failed to connect network",
            latitude: "Latitude<br/>(Decimal Degrees)",
            longitude: "Longitude<br/>(Decimal Degrees)"
        },

        //Import Dialog
        importDialog: {
            file: "File",
            format: "Format",
            foundInfo: "Info",
            foundProblem: "Problem Found",
            option: "Geo-tagging Options",
            crsWGS1984Display: "WGS84<br/>(Latitude, Longitude)",
            crsHK1980Display: "HK1980 grid system</br>(Northing, Easting)",
            inputOption: "Import Option",
            batchLocationSearch: "Automatic",
            batchLocationSearchManual: "Manual",
            batchLocationSearchManualStart: "",
            batchLocationSearchManualCoord: "by imported coordinates",
            batchLocationSearchManualAddress: "by imported location information",
            autoMatchField: 'Specify the column with location information',
            Append: "Append",
            ReplaceAll: "Replace All",
            browser: "Browse",
            none: 'None',
            selectedFile: "Selected File",
            fileChooseOrDropMessage: "Choose a file or drop it here ...",
            fileDropFileMessage: "Drop file here ...",
            // fileEmptyFileMessage: "Empty File",
            // missSelectedLatitudeLongitude: 'Please select Latitude and Longitude',
            message: 'Message',
            coordinateReferenceSystem: 'Coordinate System',
            nonPointData: "Only \"point\" data is supported for import",
            systemholdcolumnname: 'Some Field(s) of File has used by System, Please edit these field(s) to Other Field Name',
            fileAndFormatIncompatible: 'File and Format are not compatible',
            convertDateTypeFailed: 'Try to change to "Date" Type failed, Please correct the column value',
            convertNumberTypeFailed: 'Try to change to "Number" Type failed, Please correct the column value',
            notAtHKMessage: "Locations are not at supported area, you could Modify The File or Continue to input",
            reminder: "Attention",
            exportAutoMatchDownloadMessage: "-	Automatic geo-tagged data was detected. <u>Please ensure the data is checked before downloading.</u>",
            exportNotIncludeNonMarkerMessage: "- Non geo-tagged data was detected. <u>Please note that only geo-tagged data will be exported in this format.</u>",
            exporHasIEGMLNotAvailableFieldsMessage: "- Some Field(s) are not supported (i.e., chinese), please edit below field(s) to Other Field Name:",
            exportContainEmptyFieldsNameForGML: "- Blank column header is not supported in GML format.",
            exportFieldsNameStartWithLetterForGML: "- Column name must start with a letter or underscore.",
            exportOverStringSizeForGML: "- Each input cell can contain up to 5,000 characters.", 
            confirmNotMatchCorrect: "The results of automatic geo-tagging <u>by location information</u> <b>may be inaccurate</b>. Please check carefully on the generated results.",
            manualGeotagMessage: "Geo-tag your data through the map or location search.",
            exportHasDuplicatedColumnNameForCSDI: "Duplicate column names (case-insensitive match) detected. ",
            exportHasInvalidNameForCSDI: "Invalid character in column name detected. ",
            exportHasInvalidLayerNameForCSDI: "Invalid character in layer name detected. ",
            exportHasLongNameForCSDI: "Column name up to 64 characters. ",
            exportHasLongLayerNameForCSDI: "Layer name up to 160 characters. ",
            exportHasErrorAddon: "Please fix these issues in the [Column Setting].",
            exportErrorColumnNo: "column no.",
            exportErrorLayerName: "Layer name: ",
            exportGMLForCSDI: "For Common Spatial Data Infrastructure (CSDI)",
        },

        //Table
        tableOf: "of",
        indexFieldTitle: "Coordinates",
        column: "Column",
        table: "Create/Manage Data in Table",
        search: "Search",
        perPage: "Per Page",
        typeToSearch: "Filter Records",
        manageColumns: "Layer and Column Settings",
        manageColumnsShortForm: "Column",
        addBlankRecord: "Add New Record",
        deletAllRecord: "Remove All Records",
        selectedTableId: "Selected Record(No)",
        removeAllColumns: "Remove All Columns",
        extent: "Extent",
        index: "Index",
        allRecord: "All Record",
        allRecordAndCols: "All Columns and Records",
        confirmToDeleteAllRecordMessage: "Do you confirm to delete all records ?",
        confirmToDeleteAllRecordAndColsMessage: "Do you confirm to delete all columns and records ?",
        confirmToDeleteColAndRelatedRecordMessage: "Do you confirm to delete this column and related record ?",
        confirmToDeleteRecordMessage: "Do you confirm to delete this record(s) ?",
        confirmToDeleteAllColumns: "Do you confirm to delete all columns ?",
        sortableList: "Customize Columns",
        newColumnName: "New Column Name",
        add: "Add",
        removeData: "Record",
        colNameIsExistingMessage: "Duplicate column name",
        colNameIsExistingSystemUsedMessage: "This column name has already used by system",
        nocolumnMessage: "No Column",
        confirmToChangeTypeMessage: 'Do you confirm to change the column type?',
        convertDataFailedMessage: 'Change Column Type Failed. Please check the record by index: <br/><br/>',
        clearConvertDataFailedMessage: '<br/><br/> or You could clear the related column record by clicking "Clear" Button.',
        clearConvertDataFailed: 'Clear',
        addMarkerByClickMapMessage: 'Click on map to place marker',
        addBuildingLayerByClickMapMessage: 'Clicking On Map to attach Building Layer',
        addSubLayerByClickMapMessage: 'Please Select Layer And Clicking On Map To Add Layer',
        empty: "Empty",
        tableColumnDuplicated: "Duplicate column name",
        tableColumnXmlStandard: "Invalid character in column name",
        tableColumnLayerName: "Define Layer Name",

        //Filter
        //PLEASE ALSO ADD TO GLOBAL.JS
        FILTER_COMMEND: {
            NONGEOTAGGED: "Show only the non geo-tagged result",
            GEOTAGGED: "Show only the geo-tagged result",
            AUTOMATCHED: "Show only the automatic geo-tagging result (by imported location information)",
            AUTOMATCHEDXY: "Show only the automatic geo-tagging result (by imported coordinates)",
        },

        //Print
        printTitle: "Print Map",
        printPortrait: "Portrait",
        printLandscape: "Landscape",
        printAuto: "Auto",
        printCustom: "Custom",
        printCustomMessage: "Please drag area on map to print the location",

        //Draw
        radius: 'radius',
        finish: 'Finish',
        finishTitle: 'Finish drawing',
        undo: 'Delete last point',
        undoTitle: 'Delete last point drawn',
        actions: 'Finish',
        actionsTitle: 'Finish drawing',
        save: 'Save',
        saveTitle: 'Save changes',
        // cancel: 'Cancel',
        cancelTitle: 'Cancel editing, discards all changes',
        clearAll: 'Clear All',
        clearAllTitle: 'Clear all layers',

        drawAPolyLine: 'Draw polygon line',
        drawPolylineTooltipStart: 'Click to start drawing line.',
        drawPolylineTooltipCont: 'Click to continue drawing line.',
        drawPolylineTooltipEnd: 'Click last point to finish line.',

        drawPolygonTooltipStart: 'Click to start drawing shape.',
        drawPolygonTooltipCont: 'Click to continue drawing shape.',
        drawPolygonTooltipEnd: 'Click first point to close this shape.',

        drawAPolygon: 'Draw polygon',
        drawARectangle: 'Draw retangle',
        drawRectangleTooltipStart: 'Click and drag to draw rectangle.',

        drawACircle: 'Draw circle',
        drawCircleTooltipStart: 'Click and drag to draw circle.',

        drawAMarker: 'Draw marker',
        drawMarkerTooltipStart: 'Click on map to place marker.',

        drawSimpleShapeTooltipEnd: 'Release mouse to finish drawing.',

        drawEditButton: "Edit Markers",
        drawEditDisabled: "No Markers to edit",
        drawRemove: "Delete Markers",
        drawRemoveDisabled: "No Markers to delete",

        drawHandlerEditTooltip: "Drag Markers to edit features.",
        drawHandlerEditTooltipSubtext: "Click cancel to undo changes.",
        drawHandlerRemoveTooltip: "Click on a Marker to remove Record.",

        //locate
        locateTitle: 'Show Your Location',

        //button title
        title_showLeftBar: "Show Search Results",
        title_leftBarSliderDrag: "Drag Icon To Change the Left Bar's Width",
        title_tableSliderDrag: "Drag Icon To Change the Table's Height",
        title_import: "Import Data To Table",
        title_export: "Export Table Data",
        title_save: "Switch On/Off Auto Saving Function",
        title_table: "Open Table",
        title_language: "Switch Language",
        title_searchBar: "Search Location By Input Information",
        title_addLayer: "Add Layer From Web Resource",
        title_removeLayers: "Remove All Layers",
        title_tabsLayers: "Layers Setting",
        title_tabsSearchResult: "Searched Result",
        title_tabsIdentify: "Identified Location Result",
        title_tabsExtent: "Zoom To All Search Results",
        title_tabsTrash: "Clear Result",
        title_closeLeftBar: "Hide Search Results",
        title_onOffLayer: "Switch On/Off Layer",
        title_editLayer: "Edit Layer",
        title_switchLayerUp: "Go Up",
        title_switchLayerDown: "Go Down",
        title_removeLayer: "Remove Layer",
        title_close: "Close",
        title_tableClose: "Hide",
        title_openLeftBarWithLayer: "Open Left Side Bar(Layer)",
        title_zoomTo: "Zoom To",
        title_addData: "Add New Location Record To Table",
        title_copyData: "Copy To Selected Record in Table",
        title_filteSearchrBar: "Filter records by keywords",
        title_tableExtent: "Zoom to All Results",
        title_tableManageColumns: "Managment of Table Columns",
        title_addBlankRecordAtTable: "Add New Record into Table",
        title_tableRemoveAllRecord: "Remove All Table Record",
        title_tableSelectedTableId: "Selected Table Record No",
        title_tableRemoveRecord: "Remove Record",
        title_tableAddLayer: "Attach Building Layer",
        title_tableRemoveLayer: "Remove Attached Building Layer",
        title_tableItemInputSearchButton: "Quick search",

        title_manageColumnsDeleteAll: "Remove All Columns With Related Record",
        title_manageColumnsRemoveColumn: "Remove Column",
        title_manageColumnsType: "Column Type",
        title_manageColumnsName: "Column Name",

        title_addMarker: "Geo-tag on the map",

        welcomeAndAbout: {
            title: "Welcome to the Geo-tagging Tool (v1.1)",
            content: "The Geo-tagging Tool is a web application that helps users to convert textual and non-spatial data (e.g. demographic data) into a form of spatial data for displaying on a digital map and further development of geospatial applications. The Tool supports users to:",
            content_pointOne: "•    Import textual records for geo-tagging",
            content_pointTwo: "•    Geo-tag records on map interface",
            content_pointThree: "•  Download geo-tagged data in open and machine-readable formats",
            content_pointFour: "For assistance in using Geo-tagging Tool, please email to <a href='mailto:sdms_enquiry@landsd.gov.hk'>sdms_enquiry@landsd.gov.hk</a>.",

            next: "Next",
            prev: "Prev",
            close: "Close",
            done: "Done",

            mapTitle: "Geo-tag Data on Map",
            mapDescription: "Click on the suitable map location.",
            saveTitle: "Temporary Storage in Browser",
            saveDescription: "Save your processing data in browser cache. Click to disable or enable this function.",
            importTitle: "Import Data",
            importDescription: "Start to geo-tag your data by importing data from file. Supported formats include: <br/> <b>•  GeoJSON</b>; <br/> <b>•  Comma-separated values (CSV)</b>; <br/> <b>•  Keyhole Markup Language (KML)</b>; <br/> <b>•  Geography Markup Language (GML)</b>",
            locationSearchTitle: "Geo-tag data through location search",
            locationSearchDescription: "Enter the keywords of the location.",
            switchMapTitle: "Switch Map",
            switchMapDescription: "Select to switch between topographic map and orthophoto map.",
            editOrDeleteGeoTaggedDataTitle: "Edit / Delete Geo-tagged Data",
            editOrDeleteGeoTaggedDataDescription: "Edit or delete geo-tagged data on map interactively.",
            manageDataInTableTitle: "Create/Manage Data in Table",
            manageDataInTableDescription: "Click to open the table for creating, editing or deleting your data",
            downloadTitle: "Download GeoData",
            downloadDescription: "Download your geo-tagged data in open and machine-readable formats. Support formats include: <br/> <b>•  GeoJSON</b>; <br/> <b>•  Comma-separated values (CSV)</b>; <br/> <b>•  Keyhole Markup Language (KML)</b>; <br/> <b>•  Geography Markup Language (GML)</b>",

            setDefaultExtentTitle: "Back to the default extent",
            // setDefaultExtentDescription: "Set the current map extent to the default extent"
            setDefaultExtentDescription: ""

        },

        aboutDialog: {
            title: "About",
            subtitle: "Welcome to the Geo-tagging Tool (v1.1)",
            content: "The Geo-tagging Tool is a web application that helps users to convert textual and non-spatial data (e.g. demographic data) into a form of spatial data for displaying on a digital map and further development of geospatial applications. The Tool supports users to:",
            content_pointOne: "•    Import textual records for geo-tagging",
            content_pointTwo: "•    Geo-tag records on map interface",
            content_pointThree: "•  Download geo-tagged data in open and machine-readable formats",
            content_pointFour: "For assistance in using Geo-tagging Tool, please email to <a href='mailto:sdms_enquiry@landsd.gov.hk'>sdms_enquiry@landsd.gov.hk</a>.",
            title_termsAndConditions: "Terms and Conditions and Privacy Policy",
            // title_privacyPolicy: "Privacy Policy",
            tab_FAQ: "FAQ",
            title_tab_FAQ: "Frequently Asked Questions",
            tab_intro_video: "Intro Video",
            title_intro_video: "Introduction Video",

            title_FAQ1: "<b>Getting started</b>",
            title_FAQ1A: "What is “geo-tagging”?",
            content_FAQ1A: "Geo-tagging is a process of associating geographical location information, such as latitude and longitude coordinates, to non-spatial data.",
            title_FAQ1B: "What are the applications of geo-tagged data?",
            content_FAQ1B: "Geo-tagged data has a wide range of applications. For example, you could geo-tag your business, restaurants and any facilities and present them on a digital map. This type of data could also be applied in spatial analysis and developing mobile Apps, etc.",
            title_FAQ1C: "What types of data are suitable for geo-tagging?",
            content_FAQ1C: "Any subjects that contain a specific location on the earth would be suitable for geo-tagging. For example, demographic data (e.g. age, gender & income) collected at different districts and a list of retail stores with general information (e.g. store name, address & opening hour).",

            title_FAQ2: "<b>Using the Geo-tagging Tool</b>",
            title_FAQ2A: "What functions does this tool provide?",
            content_FAQ2A: "Three major functions are provided:<br/>1.	Import data for geo-tagging<br/>2.	Geo-tag data<br/>3.	Download Geodata in open and machine-readable formats",
            title_FAQ2B: "Which coordinate systems are used in this tool?",
            content_FAQ2B: "In this Tool, the coordinates of the location are referenced to the WGS84 geographical coordinates system (latitude and longitude) and the HK1980 grid coordinates system (northing and easting).",
            title_FAQ2C: "What file formats does this tool support?",
            content_FAQ2C: "This Tool supports import/download the data in open and machine-readable formats, including <b>CSV, GeoJSON, KML and GML</b>. Please note that this Tool only supports import/download \"point\" data with the above mentioned spatial data formats.",
            title_FAQ2D: "How can I import my own data to this tool?",
            content_FAQ2D: "You can either collate the data into any of the supported file formats (i.e., CSV, GeoJSON, KML & GML) and import it to this Tool via <img class=\"faq import_data_img\" alt=\"“IMPORT DATA”\" src=\"./img/faq_import_data_button_en.png\"> function (located at the top-right corner of this Tool) OR <b>manually input your data</b> in the table of this Tool.",
            title_FAQ2E: "Where can I add/edit/delete columns in the table?",
            content_FAQ2E: "1.	At the bottom-left corner, open the table by clicking <img class=\"faq table_img\" alt=\"“Create/Manage Data in Table”\" src=\"./img/faq_table_button_en.png\">.<br/><br/>2.	Click <img class=\"faq col_set_img\" alt=\"“COLUMN SETTINGS”\" src=\"./img/faq_col_set_button_en.png\"> at the top-left of the table.",
            title_FAQ2F: "How can I geo-tag data?",
            content_FAQ2F: "<b><u>Manual geo-tagging</u></b> <br/> 1.	Through the map:<br/>Step 1: Open the table by clicking <img class=\"faq table_img\" alt=\"“Create/Manage Data in Table”\" src=\"./img/faq_table_button_en.png\">.<br/>Step 2: On the left-hand side of each of the data row(s), click the marker <img class=\"faq blue_marker_img\" alt=\"blue marker\" src=\"./img/faq_blue_marker.svg\">.<br/>Step 3: Place the marker <img class=\"faq marker_img\" alt=\"marker\" src=\"./lib/images/marker-icon.png\"> on the suitable location of the map<br/><b>OR</b><br/>2.	Through the search result:<br/>Step 1: Search the location by keywords/address or left-clicking on the map<br/>Step 2: On the search result, click the icon of “Copy To Selected Record in Table” <img class=\"faq copy_data_img\" alt=\"“Copy To Selected Record in Table”\" src=\"./img/faq_copy_data_button.png\">" +
                "<br/><br/><b><u>Automatic geo-tagging</u></b> <br/>	1.	By imported coordinates:<br/> Step 1: Select “Automatic geo-tagging” during import data<br/> Step 2: Select “by imported coordinates”<br/> Step 3: Select the corresponding coordinate system and coordinates column<br/></br> 2.	By imported location information<br/> Step 1: Select “Automatic geo-tagging” during import data<br/> Step 2: Select “by imported location information”<br/> Step 3: Select the corresponding column<br/> (Attention: The automatic geo-tagging by location information may be inaccurate. Please check carefully the generated result.)",
            title_FAQ2G: "How can I amend/delete the coordinates of the geo-tagged data?",
            content_FAQ2G: "You can click the icon of “Edit Marker” <img class=\"faq edit_marker_img\" alt=\"“Edit Marker”\" src=\"./lib/images/draw_edit.png\"> and “Delete Marker” <img class=\"faq delete_marker_img\" alt=\"“Delete Marker”\" src=\"./lib/images/draw_delete.png\"> at the top-left side of the map to edit and delete the marker(s) respectively.",
            title_FAQ2H: "How can I download the geo-tagged data?",
            content_FAQ2H: "Click <img class=\"faq export_img\" alt=\"“DOWNLOAD GEODATA”\" src=\"./img/faq_export_button_en.png\"> at the top-right corner and select the desired export format.",
            title_FAQ2I: "I have a list of facilities information storing in a spreadsheet. How can I import those data to the tool for geo-tagging?",
            content_FAQ2I: "It is suggested to convert the list to a CSV format and import it to this Tool. Please be ensured that the header is included.<br/><a href=\"./src/CSV sample_ENG.csv\" target=\"_blank\"><u><i>CSV Sample File</i></u></a>",
        },

        CSVAutoMatchTour: {
            title_step1: "Step 1: Automatic geo-tagging by location information is supported",
            content_step1: "",
            title_step2: "Step 2: Select the corresponding column",
            content_step2: "",
            title_step3: "Step 3: Users could utilize the filter function for checking the automatic geo-tagging result",
            content_step3: "",
        },

        importTour: {
            title_fileSelect: "File Selection",
            content_fileSelect: "Select a file for import.",
            title_fileFormat: "File Format",
            content_fileFormat: "Select a file format.",
        },

        exportTour: {
            title_fileFormat: "File Format",
            content_fileFormat: "Select a export file format.",
        },

        LeftBarTour: {
            title_addData: "Add new record",
            content_addData: "The searched location could be used to geo-tag the new record",
            title_copyData: "Adopt the location and map information",
            content_copyData: "Copy them to the selected record in the table",
        },

        TableTour: {
            title_columnSettings: "Column Settings",
            content_columnSettings: "Add, edit or delete column",
            title_addNewRecord: "Add a new record",
            content_addNewRecord: "Add an empty record in the table",
            title_deleteAllRecord: "Delete all record",
            content_deleteAllRecord: "Delete all record",
            title_disselectRecord: "Deselect record",
            content_disselectRecord: "Deselect record",
        },

        addAndCopyTour: {
            title_add: "Adopt existing information",
            content_add: "Adopt the existing coordinates or map information for the new record",
            title_copy: "Adopt existing information",
            content_copy: "Adopt the existing coordinates or map information for the selected record",
        },

        colSetting: {
            title_remove: "Remove all columns",
            content_remove: "Remove all columns in the table",
            title_manage: "Manage columns",
            content_manage: "Renaming, re-ordering or deleting columns",
            title_new: "New columns name",
            content_new: "Naming new columns",
            title_add: "Add new columns",
            content_add: "Name and add the new column",
            title_layerName: "Define layer name",
            content_layerName: "Naming the layer name for export format to GeoJSON, KML and GML",
        },

        autoSave_titledisclaimer: "Caution",
        noAutoSave_titledisclaimer: "Caution",
        autoSave_disclaimerContent: "With this option turned on, edits will be saved to the browser cache automatically. Please note this function is browser dependent and the browser cache may be cleared by built-in functions of the browser. To avoid unintended loss, it is recommended to use the “Download GeoData” to store the records to your local storage regularly.",
        noAutoSave_disclaimerContent: "Turning off this option will clear the browser cache saved by this Tool and all the records will be lost when closing this website. <b>Before doing so, please use the “Download GeoData” to make a copy of your records. </b>",

        successfully: 'Successfully',
        failed: 'Failed',
        insert: "Append",
        edit: "Edit",
        record: "Record",
        copy: "Copy",
        remove: "Remove",
        none: 'None',
        information: "Information",
    },

}